// extracted by mini-css-extract-plugin
export var icon = "_3DMY";
export var primary = "D8he";
export var primaryOrange = "dlF2";
export var quaternary = "jNJr";
export var root = "KxiO";
export var rootButtonIcon = "_5bmM";
export var secondary = "_9kF0";
export var secondaryDark = "hrfx";
export var secondaryLight = "_5IC9";
export var secondaryOrange = "c2J-";
export var tertiary = "+sy4";
export var tertiaryDark = "XNLf";